function LogoController(__env) {
    const ctrl = this;

    ctrl.$onInit = () => {
        ctrl.logoSource = `../../images/logo-${__env.profile.toLowerCase()}.svg`;
    };
}

angular
    .module('logo.module')
    .controller('LogoController', LogoController);